var React = require('react');

function Briefcase (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M80 28H16C11.5817 28 8 31.5817 8 36V76C8 80.4183 11.5817 84 16 84H80C84.4183 84 88 80.4183 88 76V36C88 31.5817 84.4183 28 80 28Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M64 84V20C64 17.8783 63.1571 15.8434 61.6569 14.3431C60.1566 12.8429 58.1217 12 56 12H40C37.8783 12 35.8434 12.8429 34.3431 14.3431C32.8429 15.8434 32 17.8783 32 20V84","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Briefcase.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Briefcase;

Briefcase.default = Briefcase;
